import React from 'react';

import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Modal from '../../Modal';
import { ActionType } from '../types';
import { StyledCardHeader, StyledCardContent, StyledCardActions } from './index.styles';

interface PublishTemplateModalInterface {
    actionType: ActionType;
    handleUpdate: () => void;
    statusModalIsOpen: boolean;
    closePublishModal: () => void;
}

const UpdateTemplateStatusModal: React.FC<PublishTemplateModalInterface> = ({ actionType, statusModalIsOpen, closePublishModal, handleUpdate }) => {
    const { t } = useTranslation('templates');

    const title = actionType === ActionType.Publish ? t('publish-template') : t('unpublish-template');
    const infoMessage = actionType === ActionType.Publish ? t('publish-template-info-message') : t('unpublish-template-info-message');
    const updateButtonText = actionType === ActionType.Publish ? t('publish') : t('unpublish');

    return (
        <Modal noPadding isOpen={statusModalIsOpen} onClose={closePublishModal}>
            <StyledCardHeader>
                <Typography variant="h5">{title}</Typography>
            </StyledCardHeader>
            <StyledCardContent>
                {infoMessage}
            </StyledCardContent>

            <StyledCardActions>
                <Button onClick={closePublishModal} variant="outlined">{t('cancel')}</Button>
                <Button variant="contained" onClick={() => handleUpdate()}>{updateButtonText}</Button>
            </StyledCardActions>
        </Modal>
    );
};

export default UpdateTemplateStatusModal;
